<template>
  <div class="create-room">
    <navbar_staff />
    <div class="space"></div>
    <div class="container">
      <div class="add-name-room">
       
       <!-- ===================================== Modal add room =======================================-->
   
       <b-modal
         id="modal-prevent-closing"
         ref="modal"
         title="Enter room name"
         @show="resetModal"
         @hidden="resetModal"
         @ok="handleOk"
       >
         <form ref="form" @submit.stop.prevent="handleSubmit">
           <b-form-group
             label="Name"
             label-for="name-input"
             invalid-feedback="Name is required"
             :state="nameState"
           >
             <b-form-input
               id="name-input"
               v-model="name"
               :state="nameState"
               required
             ></b-form-input>
           </b-form-group>
         </form>
       </b-modal>
        <!-- ===========================================================================================-->
        
          <div class="card-columns">
            <div class="mb-6">
              <b-button pill variant="success" class="pull-right" v-b-modal.modal-prevent-closing><i class="fa-solid fa-circle-plus"></i> Add</b-button>
            </div>
            <br /> 
            <br />
            
            <div class="card card-order-list calendar-border">
              <div class="card-body">
                <b-table  striped
                hover :items="items"  responsive="sm"></b-table> 
              </div>
            </div>
         
         

          <!-- <b-table  striped
          hover :items="items"  responsive="sm">
        
        
        </b-table> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import navbar_staff from "../layouts/navbar_staff.vue";
export default {
  components: { navbar_staff },
  data() {
    return {
      items: [
        { age: 40, first_name: "Dickerson", last_name: "Macdonald" },
        { age: 21, first_name: "Larsen", last_name: "Shaw" },
        { age: 89, first_name: "Geneva", last_name: "Wilson" },
        { age: 38, first_name: "Jami", last_name: "Carney" },
      ],
      name: '',
        nameState: null,
        submittedNames: []
    };
  },
  methods: {
      checkFormValidity() {
        const valid = this.$refs.form.checkValidity()
        this.nameState = valid
        return valid
      },
      resetModal() {
        this.name = ''
        this.nameState = null
      },
      handleOk(bvModalEvent) {
        // Prevent modal from closing
        bvModalEvent.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
       
        
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        }
        // Push the name to submitted names
        this.submittedNames.push(this.name)
        console.log("name===",this.name);
        // Hide the modal manually
        this.$nextTick(() => {
          this.$bvModal.hide('modal-prevent-closing')
        })
      }
    }
};
</script>

<style lang="scss" scoped>
.create-room {
  background: var(--greyLight-1) no-repeat center center;
  background-size: cover;
  min-height: 100vh;
  position: absolute;
  width: 100%;
}
.space {
  height: 100px;
}
.card-columns .card {
  border-radius: 20px;
}
.card-columns {
  column-count: 1;
}
.card-title {
  text-align: left;
  text-align: justify;
  bottom: 10px;
}
.card-text {
  text-align: left;
  line-height: 23px;
  margin-bottom: -5px;
}
.calendar-border {
  border: none;
  background-color: var(--greyLight-1);
  border-radius: 2rem;
  box-shadow: 0.8rem 0.8rem 1.4rem var(--greyLight-2),
    -0.2rem -0.2rem 1.8rem var(--white);
}
</style>
